import React from 'react';
import {Tab, Tabs, Tooltip} from '@mui/material';
import {setSelectedMainTab, useSelectedMainTab} from '../documents/editor/EditorContext';
import Icon from "../../../components/icon";
import {useManagerContext} from "../../../sections/emails/ManagerContext";

export default function MainTabsGroup() {
    const selectedMainTab = useSelectedMainTab();
    const {errors} = useManagerContext();

    const handleChange = (_, v) => {
        switch (v) {
            case 'json':
            case 'preview':
            case 'editor':
            case 'html':
                setSelectedMainTab(v);
                return;
            default:
                setSelectedMainTab('editor');
        }
    };

    return (
        <Tabs value={selectedMainTab} onChange={handleChange}>
            <Tab
                value="editor"
                label={
                    <Tooltip title="Editor">
                        <div><Icon name="edit" /></div>
                    </Tooltip>
                }
            />
            <Tab
                value="html"
                label={
                    <Tooltip title="Custom Html">
                        <div>
                            <Icon name="code" style={{fontSize: '16px', color: errors?.['content.html'] ? 'red' : 'inherit'}} />
                            {errors?.['content.html'] && <small className="error"><strong>Error</strong></small>}
                        </div>
                    </Tooltip>
                }
            />
            <Tab
                value="json"
                label={
                    <Tooltip title="Text version">
                        <div>
                            <Icon name="text" style={{fontSize: '18px', color: errors?.['content.plain'] ? 'red' : 'inherit'}}  />
                            {errors?.['content.plain'] && <small className="error"><strong>Error</strong></small> }
                        </div>
                    </Tooltip>
                }
            />
            <Tab
                value="preview"
                label={
                    <Tooltip title="Preview">
                        <div><Icon name="preview" style={{fontSize: '16px'}} /></div>
                    </Tooltip>
                }
            />
        </Tabs>
    );
}
